import { useTranslation } from 'react-i18next';
import GlassCard from '../ui/GlassCard';
import CircularProgress from '../ui/CircularProgress';

interface MissingField {
  key: string;
  labelKey: string;
  weight: number;
  required: boolean;
}

interface ProfileCompletenessProps {
  percentage: number;
  missingFields: MissingField[];
  onFieldClick?: (fieldKey: string) => void;
}

export default function ProfileCompleteness({
  percentage,
  missingFields,
  onFieldClick,
}: ProfileCompletenessProps) {
  const { t } = useTranslation();

  return (
    <GlassCard variant="dark" className="p-4 h-full flex items-center">
      <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 w-full">
        {/* Progress circle */}
        <div className="flex-shrink-0">
          <CircularProgress percentage={percentage} size={72} strokeWidth={5} />
        </div>

        {/* Content */}
        <div className="text-center sm:text-left">
          <h2 className="text-base font-semibold text-white mb-0.5">
            {t('dashboard.completeness.title')}
          </h2>
          <p className="text-white/80 text-sm">
            {percentage === 100
              ? t('dashboard.completeness.complete')
              : t('dashboard.completeness.addMissing')}
          </p>

          {/* Missing fields */}
          {missingFields.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-2 justify-center sm:justify-start">
              {missingFields.slice(0, 3).map((field) => (
                <button
                  type="button"
                  key={field.key}
                  onClick={() => onFieldClick?.(field.key)}
                  className="px-2.5 py-1 text-[11px] bg-white/20 hover:bg-white/30 text-white rounded-full transition-colors"
                >
                  + {t(`dashboard.completeness.fields.${field.labelKey}`)}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </GlassCard>
  );
}
